import React from 'react'
import PropTypes from 'prop-types'
import { DataGrid } from '@the-platform-group/component-library/DataGrid'

import useColumnConfig from '../hooks/useColumnConfig'

const PromptsTable = ({ prompts, isLoading, onDelete }) => {
  const columns = useColumnConfig({ onDelete })

  return (
    <DataGrid
      columns={columns}
      commonColumnProps={{ headerAlign: 'left' }}
      rows={prompts}
      loading={isLoading}
      name="agenticPromptsTable"
      localeText={{
        noRowsLabel: 'No prompts match your filters yet.',
      }}
      getRowHeight={() => 'auto'}
      sx={{
        '& .MuiDataGrid-cell': { py: 1 },
      }}
    />
  )
}

PromptsTable.propTypes = {
  prompts: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
}

export default PromptsTable
